import { FC } from "react";
import { Table } from "../../../../../components/Table";
import { TableColumn } from "../../../../../components/table/TableRow";
import {
  dropdownAcoes,
  iconeAlterar,
} from "../../../../../components/cadastro";
import { naturalSort } from "../../../../../coreUtils";

interface Props {
  data: any;
  setSelected: any;
  alterar: (id: any) => void;
  excluir: (id: any) => void;
}

export const MenuGrid: FC<Props> = ({
  data,
  setSelected,
  alterar,
  excluir,
}) => {
  const columns: TableColumn[] = [
    {
      dataField: "nro_tela",
      text: "Nº Tela",
      align: "center",
      sortable: true,
      sortFunc: naturalSort,
    },
    {
      dataField: "modulo",
      text: "Módulo",
      align: "left",
      sortable: true,
    },
    {
      dataField: "descricao",
      text: "Descrição",
      align: "left",
      sortable: true,
    },
    {
      dataField: "plano",
      text: "Plano",
      align: "left",
      sortable: true,
      formatter: (c: any, row: any) => (
        <>
          <img
            src={row.icone_plano}
            style={{ width: "16px", height: "16px", marginRight: "2px" }}
          />
          {c}
        </>
      ),
    },
    iconeAlterar(alterar),
    dropdownAcoes({ excluir: excluir }),
  ];
  return (
    <Table
      data={data}
      columns={columns}
      paginated={false}
      onSelect={setSelected}
      onRowDoubleClick={alterar}
    />
  );
};
